import { Component, HostListener, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { PriceTableComponent } from 'src/modals/int-calling-list-modal/price-table/price-table.component';
import { IntCallingListData } from 'src/services/modal-helper.service';

@Component({
  selector: 'app-int-calling-list-modal',
  templateUrl: './int-calling-list-modal.component.html',
  styleUrl: './int-calling-list-modal.component.scss'
})
export class IntCallingListModalComponent {
  @ViewChild('intCalling') intCalling: PriceTableComponent;
  @ViewChild('payGo') payGo: PriceTableComponent;
  selectedIndex: number;  
  innerWidth = window.innerWidth;  

  constructor(@Inject(MAT_DIALOG_DATA) public data: IntCallingListData, public dialog: MatDialogRef<IntCallingListData>) { }

  tabChanged(event: MatTabChangeEvent) {
    if (event.index == 0)
      this.payGo.resetAllFilters();

    if (event.index == 1)
      this.intCalling.resetAllFilters();
  }

  beforeClose(): boolean {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
    return false;
  }

  closeDialog(): void {
    this.beforeClose();
    this.dialog.close();
  }

  OK(): void {
    this.beforeClose();
    this.dialog.close(true);
  }
  cancel(): void {
    this.beforeClose();
    this.dialog.close(false);
  }

  @HostListener('window:resize')
  onResize() {
    this.innerWidth = window.innerWidth;
  }
}
